import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { ContactPhone as ContactIcon } from "@mui/icons-material";
import CustomInput from "../FormFields/CustomInput/CustomInput";
import CardHeaderComponent from "./CardHeaderComponent";

const CandidateContactsForm = ({ handleChange, data }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeaderComponent icon={ContactIcon} title="Contacts" />
      <CardContent sx={{ p: 2.5 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Email"
              name="primary_email"
              onChange={handleChange}
              value={data?.primary_email || ""}
              fullWidth
              size="small"
              placeholder="Enter primary email"
              type="email"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Secondary Email"
              name="secondary_email"
              onChange={handleChange}
              value={data?.secondary_email || ""}
              fullWidth
              size="small"
              placeholder="Enter secondary email"
              type="email"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Home Phone"
              name="home_phone"
              onChange={handleChange}
              value={data?.home_phone || ""}
              fullWidth
              size="small"
              placeholder="Enter home phone"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Mobile Phone"
              name="mobile_phone"
              onChange={handleChange}
              value={data?.mobile_phone || ""}
              fullWidth
              size="small"
              placeholder="Enter mobile phone"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Contact Number"
              name="contact_number"
              onChange={handleChange}
              value={data?.contact_number || ""}
              fullWidth
              size="small"
              placeholder="Enter contact number"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Skype"
              name="skype"
              onChange={handleChange}
              value={data?.skype || ""}
              fullWidth
              size="small"
              placeholder="Enter Skype ID"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CandidateContactsForm;